module.exports = __webpack_public_path__ + "static/media/announcement_item.676b283e.jpg";